import {LinkContainer} from "react-router-bootstrap";
import {Icon, IconProps} from "../Icon";
import {motion} from "framer-motion";
import appearSlowEffect from "../animations/appearSlowEffect";
import {useEffect} from "react";

export interface GridInterface {
    title: string;
    smallerTitle?: boolean;
    subtitle?: string;
    tag: string;
    icon?: IconProps['iconName'];
    image?: string;
    extra?: unknown;
}

interface GridProps {
    options: GridInterface[];
    onClick?: (option: GridInterface, e: React.MouseEvent<HTMLElement>) => void;
}

export const GridOfOptions = ({options, onClick}: GridProps) => {
    useEffect(() => {
        document.title = "3Vids!"
    }, []);

    return (
        <div>
            <div className="d-flex flex-wrap justify-content-center h-100">
                {options.map((option) => (
                    <LinkContainer to={option.tag} onClick={(e) => {
                        if (!onClick) {
                            return
                        } else {
                            onClick(option, e)
                        }
                    }}>
                        <motion.div {...appearSlowEffect} key={option.tag}
                                    className="m-1 flex-grow-0 grid-of-options d-flex flex-column justify-content-center align-items-center"
                                    role="button">
                            {option.icon &&
                                <Icon iconName={option.icon} className="mb-1" size={50}></Icon>
                            }
                            {option.image &&
                                <img src={option.image.startsWith('/') ? option.image : `/${option.image}`} className="mb-1 image" alt={option.tag}></img>
                            }
                            <p className={option.smallerTitle ? 'small' : ''}>{option.title}</p>
                            {option.subtitle &&
                                <p className="puny">{option.subtitle}</p>
                            }
                        </motion.div>
                    </LinkContainer>
                ))}
            </div>
        </div>
    );
};